module.exports = __webpack_public_path__ + "static/dashboard_en_bg-40bd6be9d44cf0e9810482a21dfc1397.png";